import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/**
 * Floating button that appears after the user scrolls > threshold pixels and
 * scrolls the page smoothly back to top when clicked. AdSense-compliance UX.
 */
export default function BackToTopButton({ threshold = 400 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top"
      aria-label="Torna in cima"
      className="fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full bg-[#FBD51C] hover:bg-[#F5C518] text-black shadow-lg shadow-black/40 flex items-center justify-center transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#FBD51C]/60"
    >
      <ChevronUp size={20} strokeWidth={2.5} />
    </button>
  );
}
